<div *ngIf="index===0" id="container0"></div>
<div *ngIf="index===1" id="container1"></div>
<div *ngIf="index===2" id="container2"></div>
<div *ngIf="index===3" id="container3"></div>
<div *ngIf="index===4" id="container4"></div>
<div *ngIf="index===5" id="container5"></div>
<div *ngIf="index===6" id="container6"></div>